<template>
    <div class="user_descriptions">

        <div class="url_settings mb-5 mt-3">
            <yes_no
                @change="loadBaseUrl"
                key="BASE_URL_TYPE"
                v-model="pwa.base_url_type"
                :radio_options="base_url_options"
                title="URL_TYPE">

            </yes_no>

            <div class="url_info">
                <b-overlay :show="is_load_ulr">
                    <div class="form-group mt-5" >
                        <label class="form-label" for="pwa.base_url">
                            {{__t('pwa.base_url')}}
                        </label>

                        <div class="input-group flex-nowrap">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fal fa-address-book  fs-xl" ></i>
                                </span>
                            </div>

                            <b-form-input
                                :disabled="!can_edit_url"
                                class="form-control"
                                id="pwa.base_url"
                                v-model="pwa.base_url">

                            </b-form-input>
                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>



        <div class="row mb-5">
            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="GEO_ON_START"
                    title="PWA_GEO_ON_START"
                    v-model="is_geo_on"
                >
                </yes_no>
            </div>

            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="PAY_TABLE"
                    title="PAY_TABLE"
                    v-model="pay_table"
                >
                </yes_no>
            </div>

            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="SMS_AUTH_STATE"
                    title="SMS_AUTH_STATE"
                    v-model="sms_auth"
                >
                </yes_no>

            </div>

            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="SHOW_CONTACT_FORM"
                    title="SHOW_CONTACT_FORM"
                    v-model="pwa.show_contact_form"
                >
                </yes_no>
            </div>

        </div>

        <div class="row mb-5">
            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="SHOW_CATALOG_STOP"
                    title="SHOW_CATALOG_STOP"
                    v-model="pwa.show_catalog_stop"
                >
                </yes_no>
            </div>


            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="USE_ESTIMATE"
                    title="USE_ESTIMATE"
                    v-model="pwa.use_estimate"
                >
                </yes_no>
            </div>

            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="PAY_BONUS"
                    title="PAY_BONUS"
                    v-model="pay_bonus"
                >
                </yes_no>
            </div>

            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="ALLOW_INSTALL"
                    title="ALLOW_INSTALL"
                    v-model="allow_install"
                >
                </yes_no>
            </div>

        </div>

        <!--
        <div class="row mb-5">
            <div class="col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" >
                <yes_no
                    key="SHOW_RESERVATION"
                    title="SHOW_RESERVATION"
                    v-model="pwa.show_reservation"
                >
                </yes_no>
            </div>

        </div>
-->


            <div class="form-group mt-5" v-if="pay_bonus">
            <label class="form-label" for="pwa.bonus_max_percent">
                {{__t('pwa.bonus_max_percent')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>

                <b-form-input
                    min="0"
                    max="100"
                    class="form-control"
                    id="pwa.bonus_max_percent"
                    v-model="pwa.bonus_max_percent"
                >
                </b-form-input>
            </div>
        </div>




        <div class="form-group mt-2">
            <label class="form-label" for="pwa.default_geo_radius">
                {{__t('pwa.default_geo_radius')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>

                <b-form-input
                    class="form-control"
                    id="pwa.default_geo_radius"
                    v-model="default_geo_radius"
                >
                </b-form-input>
            </div>
        </div>




        <div class="form-group mt-2">
            <label class="form-label" for="pwa.default_delivery_price">
                {{__t('pwa.default_delivery_price')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>


                <b-form-input
                    class="form-control"
                    id="pwa.default_delivery_price"
                    v-model="default_delivery_price"
                >
                </b-form-input>
            </div>
        </div>


        <div class="form-group mt-2">
            <label class="form-label" for="pwa.default_delivery_min_price">
                {{__t('pwa.default_delivery_min_price')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>


                <b-form-input
                    class="form-control"
                    id="pwa.default_delivery_min_price"
                    v-model="default_delivery_min_price"
                >
                </b-form-input>
            </div>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="pwa.default_delivery_price">
                {{__t('pwa.default_delivery_time')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>

                <b-form-input
                    class="form-control"
                    id="pwa.default_delivery_time"
                    v-model="default_delivery_time"
                >
                </b-form-input>
            </div>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="pwa.default_delivery_price">
                {{__t('pwa.phones')}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-address-book  fs-xl" ></i>
                    </span>
                </div>

                <b-form-input
                    class="form-control"
                    id="pwa.phones"
                    v-model="default_phones"
                >
                </b-form-input>
            </div>
        </div>


        <div class="form-group main_discount_org">
            <div class="form-group mt-2">
                <label class="form-label" for="organization">
                    {{__t("pwa.discount_program_org")}}
                </label>

                <div class="" v-if="organizations.length > 0">
                    <v-select v-model="active_org" class="imc_reasons" label="title" :options="this.organizations" :filterable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_ORG")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.title }}
                                    <span class="small badge border border-info  text-info mr-1"> {{option.provider}}</span>
                                </div>
                                <div>
                                    <small>
                                        {{option.uniq_id}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import yes_no from "../../../../sys/radio/yes_no.vue";
import Info_field from "../../../../sys/info_field.vue";
import vSelect from 'vue-select'

export default {
    name: "pwa_main_info",
    props: {
        user: {
            type: Object
        },

        pwa : {
            type:Object
        }
    },

    components: {
        Info_field,
        yes_no,
        VueEditor,
        vSelect,
    },

    created() {
        this.load_organizations();
    },

    data() {
        return {
            is_load: false,
            is_load_ulr : false,
            inp_fields : [],
            organizations : [],
            base_url_options : [
                {text: 'IN_SEGMENT',  value: 'in_segment'},
                {text: 'IN_DOMAIN', value: 'in_domain'},
                {text: 'CUSTOM', value: 'custom'},
            ],
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
        }
    },

    methods : {

        async loadBaseUrl() {
            this.is_load_ulr = true;
            await agr_api.get('aggregators/pwa/general_settings/base_url/' + this.pwa.base_url_type,{}).then(({data}) => {
                this.is_load_ulr = false;
                if (data.status === "operation_success") {

                    this.pwa.base_url = data.data;
                }

            }).catch(({response}) => {
                this.is_load_ulr = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    position : "b-toaster-top-left",
                    type: "danger",
                    title: response.data.status})
            });
        },

        async load_organizations() {
            this.organizations = [];
            await api.post('/internal/v1/catalog/organizations',{}).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.organizations = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    position : "b-toaster-top-left",
                    type: "danger",
                    title: response.data.status})
            });
        },
    },

    computed : {

        sms_auth : {
            get()  {
                return this.pwa.sms_auth;
            },
            set(val)  {
                this.pwa.sms_auth = val;
            }
        },

        default_geo_radius : {
            get()  {
                return this.pwa.geo.default_geo_radius;
            },
            set(val)  {
                this.pwa.geo.default_geo_radius = val;
            }
        },

        default_delivery_time : {
            get()  {
                return this.pwa.geo.default_delivery_time;
            },
            set(val)  {
                this.pwa.geo.default_delivery_time = val;
            }
        },


        default_phones : {
            get()  {
                return this.pwa.phones;
            },
            set(val)  {
                this.pwa.phones = val;
            }
        },

        default_delivery_price : {
            get()  {
                return this.pwa.geo.default_delivery_price;
            },
            set(val)  {
                this.pwa.geo.default_delivery_price = val;
            }
        },

        default_delivery_min_price : {
            get()  {
                return this.pwa.geo.default_delivery_min_price;
            },
            set(val)  {
                this.pwa.geo.default_delivery_min_price = val;
            }
        },

        is_geo_on : {
            get()  {
                return this.pwa.is_geo_on;
            },
            set(val)  {
                this.pwa.is_geo_on = val;
            }
        },

        pay_table : {
            get()  {
                return this.pwa.pay_table;
            },
            set(val)  {
                this.pwa.pay_table = val;
            }
        },
        allow_install : {
            get()  {
                return this.pwa.allow_install;
            },
            set(val)  {
                this.pwa.allow_install = val;
            }
        },

        pay_bonus : {
            get()  {
                return this.pwa.pay_bonus;
            },
            set(val)  {
                this.pwa.pay_bonus = val;
            }
        },

        can_edit_url() {

            let url_type = this.pwa.base_url_type;
            console.log(url_type,this.pwa);

            if(url_type == 'in_domain' || url_type == 'in_segment') {
                return false;
            }

            return true;
        },
       /* show_double_currency : {

        },*/

        active_org : {
            get :function () {
                let active = null;
                if(this.organizations.length > 0) {
                    if(this.pwa.hasOwnProperty("main_discount_org")) {
                        this.organizations.map(item => {
                            if(parseInt(item.id) === parseInt(this.pwa.main_discount_org)) {
                                active = item;
                            }
                        })
                    }
                }
                return active;
            },

            set: function (val){

                if(val != null) {
                    this.pwa.main_discount_org = val.id;
                }
                else {
                    this.pwa.main_discount_org = val;
                }
            },
        },

    }




}
</script>

<style scoped>

</style>
